"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style/default.scss");

require("../lang");

require("./style/my-images.scss");

var _config = require("../config");

var _imageProxyHelper = _interopRequireDefault(require("../helpers/image-proxy-helper"));

var _withContext = _interopRequireDefault(require("../helpers/with-context"));

var _infiniteGrid = _interopRequireDefault(require("../controls/infinite-grid"));

var _controlQuery = require("@eig-builder/control-query");

var _hooks = require("../hooks");

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _authUploadHelper = _interopRequireDefault(require("../helpers/auth-upload-helper"));

var _fetch = _interopRequireDefault(require("@eig-builder/core-utils/fetch"));

var _urlHelper = require("@eig-builder/core-utils/helpers/url-helper");

var _myImages2 = require("./my-images");

var getWordPressImages = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(siteId) {
    var tokenFromAuthCheck, imageTokenHeader, apiUrl, wordpressData, data, dataJson;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _authUploadHelper["default"].checkAuth();

          case 2:
            tokenFromAuthCheck = _context.sent;
            imageTokenHeader = new window.Headers({
              Authorization: "Bearer ".concat(tokenFromAuthCheck)
            });
            apiUrl = (0, _urlHelper.api)("/v1.0/plugin/".concat(siteId, "/images"), 'wordpress');
            _context.next = 7;
            return (0, _fetch["default"])(apiUrl, {
              method: 'GET',
              headers: imageTokenHeader
            });

          case 7:
            wordpressData = _context.sent;
            _context.next = 10;
            return wordpressData;

          case 10:
            data = _context.sent;
            _context.next = 13;
            return data.json();

          case 13:
            dataJson = _context.sent;
            return _context.abrupt("return", (dataJson || []).map(function (x) {
              var _x$meta_data, _x$meta_data2;

              return {
                image_id: x.id,
                account_id: null,
                hash: x.url,
                file_name: x.name,
                thumbnail: x.thumbnail,
                image_uri: x.url,
                modified: x.date,
                original_url: x.url,
                height: (_x$meta_data = x.meta_data) === null || _x$meta_data === void 0 ? void 0 : _x$meta_data.height,
                width: (_x$meta_data2 = x.meta_data) === null || _x$meta_data2 === void 0 ? void 0 : _x$meta_data2.width
              };
            }));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getWordPressImages(_x) {
    return _ref.apply(this, arguments);
  };
}();

var WordpressImages = function WordpressImages(_ref2) {
  var _tags$tag, _tags$tag$split;

  var onUseImages = _ref2.onUseImages,
      tags = _ref2.tags,
      setActionTop = _ref2.setActionTop;

  var _useActiveView = (0, _hooks.useActiveView)('wordpress-images'),
      active = _useActiveView.active;

  var siteIdFromTag = (tags === null || tags === void 0 ? void 0 : (_tags$tag = tags.tag) === null || _tags$tag === void 0 ? void 0 : (_tags$tag$split = _tags$tag.split('-')) === null || _tags$tag$split === void 0 ? void 0 : _tags$tag$split[1]) || null;

  var getImageSizes = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(imageUrl) {
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve) {
                var loadImage = new window.Image();

                loadImage.onload = function () {
                  resolve({
                    height: loadImage.height,
                    width: loadImage.width
                  });
                };

                loadImage.src = imageUrl;

                loadImage.onerror = function (message) {
                  return resolve({
                    error: message
                  });
                };
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getImageSizes(_x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var mapImages = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(image) {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(resolve, reject) {
                  var imageProxyHelper, imageProxyThumb, _yield$getImageSizes, thumbHeight, thumbWidth, originalProxyUrl, cdnUrl, _yield$getImageSizes2, originalHeight, originalWidth, obj;

                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          // create thumbnail cdn and resize it
                          imageProxyHelper = new _imageProxyHelper["default"](image.image_uri, 'cloudflare');
                          imageProxyHelper.resizeToWidth(_config.MAX_THUMBNAIL_WIDTH);
                          imageProxyThumb = imageProxyHelper.result(); // get those sizes

                          _context3.next = 5;
                          return getImageSizes(imageProxyThumb);

                        case 5:
                          _yield$getImageSizes = _context3.sent;
                          thumbHeight = _yield$getImageSizes.height;
                          thumbWidth = _yield$getImageSizes.width;
                          // same for the original url
                          originalProxyUrl = new _imageProxyHelper["default"](image.image_uri, 'cloudflare');
                          cdnUrl = originalProxyUrl.result();
                          _context3.next = 12;
                          return getImageSizes(cdnUrl);

                        case 12:
                          _yield$getImageSizes2 = _context3.sent;
                          originalHeight = _yield$getImageSizes2.height;
                          originalWidth = _yield$getImageSizes2.width;
                          obj = {
                            thumbnail: imageProxyThumb,
                            thumbnailWidth: thumbWidth,
                            thumbnailHeight: thumbHeight,
                            original: cdnUrl,
                            originalWidth: originalWidth,
                            originalHeight: originalHeight,
                            tags: [],
                            caption: '',
                            color: image.color || '#eee',
                            source: 'uploads',
                            image_id: image.image_id
                          };
                          resolve(obj);

                        case 17:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x4, _x5) {
                  return _ref5.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function mapImages(_x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var mapImagesSync = function mapImagesSync(image) {
    var width = image.width,
        height = image.height,
        thumbnail = image.thumbnail,
        originalUrl = image.original_url,
        imageId = image.image_id;
    return {
      thumbnail: thumbnail,
      original: originalUrl,
      originalWidth: width || 500,
      originalHeight: height || 500,
      tags: [],
      caption: '',
      color: '#eee',
      source: 'uploads',
      imageId: imageId
    };
  };

  var mapAndFilterImages = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(images) {
      var mappedImages;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return Promise.all(images.map( /*#__PURE__*/function () {
                var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(image) {
                  var mappedImages;
                  return _regenerator["default"].wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return mapImages(image);

                        case 2:
                          mappedImages = _context5.sent;
                          return _context5.abrupt("return", mappedImages);

                        case 4:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }()));

            case 2:
              mappedImages = _context6.sent;
              return _context6.abrupt("return", mappedImages.filter(function (image) {
                return !image.error;
              }));

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function mapAndFilterImages(_x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  var getMyWordPressImages = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(key, siteId) {
      var images, imagesToReturn, mapped;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return getWordPressImages(siteId);

            case 2:
              images = _context7.sent;

              if (!(images.length > 0 && images[0].height && images[0].width)) {
                _context7.next = 8;
                break;
              }

              imagesToReturn = images.map(mapImagesSync);
              return _context7.abrupt("return", imagesToReturn);

            case 8:
              _context7.next = 10;
              return mapAndFilterImages(images);

            case 10:
              mapped = _context7.sent;
              return _context7.abrupt("return", mapped);

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function getMyWordPressImages(_x8, _x9) {
      return _ref8.apply(this, arguments);
    };
  }();

  var queryCache = (0, _controlQuery.useQueryCache)();
  var queryData = queryCache.getQueryData(['wordpress', siteIdFromTag]);

  var _useQuery = (0, _controlQuery.useQuery)(['wordpress', siteIdFromTag], getMyWordPressImages, {
    enabled: active,
    refetchOnWindowFocus: false,
    initialData: queryData
  }),
      status = _useQuery.status,
      images = _useQuery.data,
      isFetching = _useQuery.isFetching,
      refetch = _useQuery.refetch;

  _react["default"].useEffect(function () {
    if (active) {
      setActionTop([]);

      if (!Array.isArray(images)) {
        refetch();
      }
    }
  }, []);

  if (!active) {
    return null;
  }

  var onImageClick = function onImageClick(index) {
    return onUseImages(images[index], true);
  };

  var dataToDisplay = (images || []).map(function (photo, index) {
    return {
      onClick: function onClick() {
        return onImageClick(index);
      },
      src: photo.thumbnail,
      width: photo.originalWidth,
      height: photo.originalHeight,
      backgroundColor: photo.color,
      key: "".concat(photo.imageId)
    };
  });

  if (Array.isArray(dataToDisplay) && dataToDisplay.length === 0 && !isFetching && status === 'success') {
    return /*#__PURE__*/_react["default"].createElement(_myImages2.NoImagesBox, null, /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: "imagepicker.noImagesYet"
    }));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view default"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ip-view-content full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "images"
  }, /*#__PURE__*/_react["default"].createElement(_infiniteGrid["default"], {
    data: dataToDisplay,
    loading: isFetching
  }))));
};

WordpressImages.propTypes = {
  onUseImages: _propTypes["default"].func,
  tags: _propTypes["default"].object,
  setActionTop: _propTypes["default"].func.isRequired
};

var _default = (0, _withContext["default"])(WordpressImages);

exports["default"] = _default;